import React, { useEffect, useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { fetchContributionPlanByID } from "../action";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
const Content = styled(Typography)`
  margin-bottom: 0.5rem;

`;
const ContributionPlanPicker = ({
  input,
  reset,
  label = null,
  required = false,
  value,
  ...props
}) => {
  const SignInSuccess = useSelector((state) => state);
  const [selectedValue, setSelectedValue] = useState("");
  const [policyHolderId, setPolicyHolderId] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyholderUserResponseData) {
      setPolicyHolderId(SignInSuccess?.profileReducer?.policyholderUserResponseData?.[0].policyHolder)
    }
  }, [policyHolderId, SignInSuccess])
  useEffect(() => {
    dispatch(fetchContributionPlanByID(policyHolderId?.id));
  }, [policyHolderId]);

  const contributionData = useSelector(
    (state) => state?.profileReducer?.contributionPlanByIdResponseData
  );

  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          {contributionData &&
            contributionData.map((contributionPlan) => (
              <MenuItem key={contributionPlan.contributionPlanBundle.id} value={contributionPlan.contributionPlanBundle.id}>
                {contributionPlan.contributionPlanBundle.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
};

export default ContributionPlanPicker;
